<template>
  <Modal
    @close="$emit('close')"
    :title="'Descargar Reportes de Actividad Mensual por Curso'"
    classes="col-lg-5"
  >
    <div slot="body" class="body">
      <DownloadMonthlyReportsView />
    </div>
  </Modal>
</template>

<script>
import Modal from "@/components/Modal";
import DownloadMonthlyReportsView from "@/components/userProfile/DownloadMonthlyReportsView";

export default {
  name: "MonthlyReportsModal",
  components: {
    Modal,
    DownloadMonthlyReportsView,
  },
};
</script>
